import React from 'react';
import { Flex } from 'antd';
import { RefreshIcon } from '@/assets/icons/icons';
import { CustomShipmentText } from '@/components';

type InventoryHeaderProps = {
  title: string;
  isManualRefreshing: boolean;
  freshnessText: string;
  onRefresh: () => void;
};

const InventoryHeader: React.FC<InventoryHeaderProps> = ({
  title,
  isManualRefreshing,
  freshnessText,
  onRefresh,
}) => (
  <Flex align='center' gap={12} className='inventory-page-header'>
    <p className='zl-heading-24' style={{ margin: 0 }}>
      {title}
    </p>
    <button
      type='button'
      onClick={onRefresh}
      disabled={isManualRefreshing}
      className='refresh-btn'
      style={{
        cursor: isManualRefreshing ? 'not-allowed' : 'pointer',
      }}
    >
      <span
        className={`inventory-refresh-icon ${
          isManualRefreshing ? 'rotating' : ''
        }`}
      >
        <RefreshIcon width={12} height={12} color='var(--text-primary)' />
      </span>
      <span className='refresh-btn-label'>Refresh data</span>
    </button>
    <div className='update-text'>
      <CustomShipmentText
        text={`Last update: ${freshnessText}`}
        fontSize='10px'
        style={{ fontStyle: 'italic' }}
      />
    </div>
  </Flex>
);

export default InventoryHeader;
